export default {
    SET_REVIEWS(state, reviews) {
      state.reviews = reviews;
    },
    SET_LECTURES(state, lectures) {
        state.lectures = lectures;
    },

  };